import { ReactNode } from 'react'

import { DEFAULT_FORMATTER_LOCALE } from '../../../../constants/defaultFormatterLocale'
import { DateTimeFormat } from '../../../../utils/DateTimeFormat'
import { FormattedElement } from '../../../elements/FormattedElement'
import { FormattedDateTimeProps } from '../../FormattedDateTime'

export interface FormattedTimeProps
  extends Omit<FormattedDateTimeProps, 'options'>,
    Pick<Intl.DateTimeFormatOptions, 'timeStyle'> {
  options?: Omit<Intl.DateTimeFormatOptions, 'dateStyle'>
}

export const FormattedTime = ({
  as = 'span',
  asString = false,
  locale = DEFAULT_FORMATTER_LOCALE,
  options,
  timeStyle,
  value,
}: FormattedTimeProps): ReactNode => {
  return (
    <FormattedElement as={as} asString={asString}>
      {DateTimeFormat.getFormattedTime(value, locale, { ...(options || {}), timeStyle })}
    </FormattedElement>
  )
}
